// src/App.js (Updated)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import LandingPage from './components/landing/LandingPage';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import Profile from './components/auth/Profile';
import Settings from './components/settings/Settings';
import Dashboard from './components/layout/Dashboard';
import './App.css';

import PricingPlans from './components/subscription/PricingPlans';
import SubscriptionManager from './components/subscription/SubscriptionManager';
import PaymentSuccess from './components/subscription/PaymentSuccess';
import PaymentCancel from './components/subscription/PaymentCancel';

import LearnerList from './components/learners/LearnerList';
import LearnerRegistrationForm from './components/learners/LearnerRegistrationForm';
import LearnerDetail from './components/learners/LearnerDetail';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>

            <Route path="/pricing" element={<PricingPlans />} />
            <Route path="/subscription" element={
              <PrivateRoute requireProfile>
                <SubscriptionManager />
              </PrivateRoute>
            } />
            <Route path="/subscription/success" element={<PaymentSuccess />} />
            <Route path="/subscription/cancel" element={<PaymentCancel />} />
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            
            {/* Protected Routes */}
            <Route path="/profile" element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            } />

            <Route path="/settings" element={
              <PrivateRoute requireProfile>
                <Settings />
              </PrivateRoute>
            } />
            
            <Route path="/dashboard" element={
              <PrivateRoute requireProfile>
                <Dashboard />
              </PrivateRoute>
            } />

            {/* Learner Management Routes */}
            <Route path="/learners" element={
              <PrivateRoute requireProfile>
                <LearnerList />
              </PrivateRoute>
            } />
            
            <Route path="/learners/register" element={
              <PrivateRoute requireProfile>
                <LearnerRegistrationForm />
              </PrivateRoute>
            } />
            
            <Route path="/learners/edit/:id" element={
              <PrivateRoute requireProfile>
                <LearnerRegistrationForm isEdit={true} />
              </PrivateRoute>
            } />
            
            <Route path="/learners/detail/:id" element={
              <PrivateRoute requireProfile>
                <LearnerDetail />
              </PrivateRoute>
            } />
            
            {/* Catch all - redirect to landing */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;